export default {"src":"/_next/static/image/public/images/icons4/2.bc911c2738be902d171d6ab3fd70b074.svg","height":43,"width":43};